import React from 'react';
import Checkbox from '@/components/common/Checkbox/Checkbox';

class Option extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { props } = this;
    const { option } = props;

    const handleSelect = () => {
      if (props.selected.map((s) => s.value).indexOf(option.value) !== -1) {
        props.onUpdateState(
          { selected: props.selected.filter((s) => s.value !== option.value) },
          () => {
            if (props.onChange) {
              props.onChange(option, 'removed');
            }
          }
        );
      } else {
        props.onUpdateState({ selected: [...props.selected, option] }, () => {
          if (props.onChange) {
            props.onChange(option);
          }
        });
      }
    };

    return (
      <div key={`selectOptionKey_${option.label}`} class="selectOption">
        <div class="optionTrigger">
          <Checkbox
            checked={
              props.selected.map((s) => s.value).indexOf(option.value) !== -1
            }
            onChange={handleSelect}
          />
          {props.renderOption ? (
            props.renderOption(option)
          ) : (
            <span>{option.label}</span>
          )}
        </div>
      </div>
    );
  }
}

export default Option;
